import DynamicRouterView from '@/components/common/layout/DynamicRouterView.vue';

import DocumentsHome from '@/components/documents/DocumentsHome.vue';
import DocumentsByProduct from '@/components/documents/DocumentsByProduct.vue';
import DocumentsByContract from '@/components/documents/DocumentsByContract.vue';

import store from '@/store';

function isProduct(params) {
  const products = (store.getters['rater/products']);
  const productId = parseInt(params.productId, 10);
  return products.some(({ id }) => id === productId);
}

const documents = {
  path: 'documents',
  component: DynamicRouterView,
  children: [
    { path: '', component: DocumentsHome, name: 'clientDocuments' },
    {
      path: ':productId',
      component: DocumentsByProduct,
      name: 'clientDocumentByProduct',
      beforeEnter: (to, from, next) => {
        if (isProduct(to.params)) {
          next();
        } else {
          next('/client/documents');
        }
      },
    },
    {
      path: ':productId/:contractId',
      component: DocumentsByContract,
      name: 'clientDocumentByContract',
      beforeEnter: (to, from, next) => {
        if (isProduct(to.params)) {
          next();
        } else {
          next('/client/documents');
        }
      },
    },
    { path: '*', component: DocumentsHome, name: 'clientDocumentsFallback' },
  ],
};

export default documents;
